<template>
    <div>
        <ul class="errors-list" v-if="errors.length !== 0">
            <li v-for="(error, index) in errors" :key="index">
                {{ error }}
            </li>
        </ul>

        <ul class="info-list" v-if="infos.length !== 0">
            <li v-for="(info, index) in infos" :key="index">
                {{ info }}
            </li>
        </ul>

        <div v-if="loading" class="loading">
            <v-icon class="mdi mdi-loading mdi-spin" style="font-size: 50px; color: black;"></v-icon>
        </div>


        <v-expansion-panels style="z-index: 0;">
            <!-- Iterate through categories -->
            <v-expansion-panel v-for="(subcategories, category) in sortedDocuments" :key="category"
                style="background-color: #dbdbdb;">
                <v-expansion-panel-header @click="toggleCategory(category)">
                    {{ category }}
                </v-expansion-panel-header>

                <v-expansion-panel-content v-show="expandedCategory === category">
                    <!-- Iterate through subcategories -->
                    <v-expansion-panels>
                        <v-expansion-panel v-for="(documents, subcategory) in subcategories" :key="subcategory"
                            style="background-color: rgb(196 195 195);">
                            <v-expansion-panel-header @click="toggleSubcategory(category, subcategory)">
                                {{ subcategory }}
                            </v-expansion-panel-header>

                            <v-expansion-panel-content v-show="expandedSubcategory[category] === subcategory">
                                <table class="document-grid">
                                    <thead>
                                        <tr style="height: 30px;">
                                            <th style="font-weight: bold">Document Name</th>
                                            <th style="font-weight: bold; min-width: 350px;">Document</th>
                                            <th style="font-weight: bold">Note</th>
                                            <th style="font-weight: bold">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(doc, index) in documents" :key="index">
                                            <td>{{ doc.DocumentName }}</td>
                                            <td>
                                                <div>
                                                    <a v-if="!(
                                                        editDocumentCategoryIndex === category &&
                                                        editDocumentIndex === index &&
                                                        editDocumentSubCategoryIndex === subcategory
                                                    )" :href="doc.DocumentPath" target="_blank">
                                                        View Document
                                                    </a>
                                                    <v-file-input v-else accept=".pdf" label="Upload PDF" dense outlined
                                                        hide-details show-size class="ma-0 pa-1"
                                                        style="max-width: 250px; font-size: 13px;"
                                                        @change="handleFileUpload" />
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <p style="margin: 0px;" v-if="!(
                                                        editDocumentCategoryIndex === category &&
                                                        editDocumentIndex === index &&
                                                        editDocumentSubCategoryIndex === subcategory
                                                    )">

                                                        <span v-if="doc.Note">{{ doc.Note }}</span>
                                                        <span v-else>-</span>
                                                    </p>
                                                    <!-- <input class="note-input" v-else type="text" v-model="noteEdits[doc.id]" -->
                                                    <!-- :placeholder="doc.Note" /> -->
                                                    <v-text-field v-else v-model="noteEdits[doc.id]" label="Add a note"
                                                        type="text" outlined dense hide-details
                                                        :rules="[v => (v && v.length <= 500) || 'Max 500 characters allowed']"></v-text-field>
                                                </div>
                                            </td>
                                            <td>
                                                <svg v-if="!(
                                                    editDocumentCategoryIndex === category &&
                                                    editDocumentIndex === index &&
                                                    editDocumentSubCategoryIndex === subcategory
                                                )" @click="handleOnClickDocumentEdit(index, category, subcategory, doc)"
                                                    width="22" height="22" viewBox="0 0 24 24" style="cursor: pointer;">
                                                    <path :d="mdiPencil" />
                                                </svg>
                                                <div v-else style="display: flex; gap: 10px; align-items: center;">
                                                    <svg @click="submitDocument(doc, subcategory)"
                                                        xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                        style="cursor: pointer; margin-top: 3px;" fill="currentColor"
                                                        class="bi bi-file-earmark-arrow-up">
                                                        <path
                                                            d="M8.5 11.5a.5.5 0 0 1-1 0V7.707L6.354 8.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 7.707z" />
                                                        <path
                                                            d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                                    </svg>
                                                    <p class="close-btn" @click="setNullEditDocumentIndex()">X</p>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>




        <div v-if="driverId && !loading && (!sortedDocuments || Object.keys(sortedDocuments).length === 0)">
            <p>No documents found for this driver.</p>
        </div>


        <div v-if="!driverId">
            <p>Please select a driver</p>
        </div>

    </div>
</template>

<script>
import axios from "axios";
import { mdiPencil } from '@mdi/js'
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
Vue.use(Vuetify);
export default {
    name: "ListDriverDocuments",
    props: {
        driverId: {
            type: Number,
            required: true,
            default: 0
        }
    },
    name: "MyDocumentAccordion",
    vuetify: new Vuetify(),

    data() {
        return {
            noteEdits: {},
            mdiPencil,
            errors: [],
            loading: false,
            documents: [],
            editDocumentIndex: null,
            editDocumentCategoryIndex: null,
            editDocumentSubCategoryIndex: null,
            selectedFile: null,
            infos: [],
            expandedCategory: null,
            expandedSubcategory: {},
        };
    },

    computed: {
        sortedDocuments() {
            if (!Array.isArray(this.documents.Documents)) return {};

            // return this.testDocuments.reduce((acc, doc) => {
            return this.documents.Documents.reduce((acc, doc) => {
                const category = doc.CategoryName || "Uncategorized";
                const subcategory = doc.SubCategoryName || "No Subcategory";

                if (!acc[category]) {
                    acc[category] = {};
                }
                if (!acc[category][subcategory]) {
                    acc[category][subcategory] = [];
                }
                acc[category][subcategory].push(doc);
                return acc;
            }, {});
        }
    },

    methods: {
        async getDocumentsByDriverID() {
            if (!this.driverId) {
                this.errors.push("Driver ID is required.");
            }

            if (this.errors.length !== 0) return;

            this.loading = true;
            this.error = null;
            console.log("payload", this.driverId);

            try {
                const response = await axios.get(`/driver-management/get-documents/${this.driverId}`, {
                    headers: { Authorization: "Bearer " + this.$store.state.token }
                });

                this.documents = response.data.documents || [];
                console.log("driver documents ", this.documents);
            } catch (err) {
                console.error("Error occurred:", err);
                this.error = err.response ? err.response.data.message : err.message;
            } finally {
                this.loading = false;
            }
        },


        handleOnClickDocumentEdit(index, category, subcategory, doc) {
            this.editDocumentIndex = index;
            this.editDocumentCategoryIndex = category;
            this.editDocumentSubCategoryIndex = subcategory;
            this.selectedFile = null;
            this.noteEdits[doc.id] = doc.Note;
        },


        handleFileUpload(file) {
            if (Array.isArray(file)) this.selectedFile = file[0];
            else this.selectedFile = file;
        },


        setNullEditDocumentIndex() {
            this.editDocumentIndex = null;
            this.editDocumentCategoryIndex = null;
            this.editDocumentSubCategoryIndex = null;
            this.selectedFile = null;
            this.errors = []
            this.noteEdits = {};
        },

        emptyAndPushInfo(info) {
            this.infos = []
            this.infos.push(info)
        },

        async submitDocument(doc, SubCategory) {
            const id = doc.id;
            const DocumentName = doc.DocumentName;
            const newNote = this.noteEdits[id];
            const OldNote = doc.Note;

            const hasFile = !!this.selectedFile;
            const hasNote = newNote && newNote !== OldNote;

            if (!hasFile && !hasNote) {
                this.errors.push("Please upload a file or write a new note before submitting.");
                return;
            }

            const formData = new FormData();
            formData.append("id", parseInt(id, 10));
            formData.append("SubCategory", SubCategory);
            formData.append("DocumentName", DocumentName);
            formData.append("driverId", this.driverId);

            if (hasFile) {
                formData.append("Document", this.selectedFile);
            }

            if (hasNote) {
                formData.append("Note", newNote);
            }

            console.log("Patch payload:", Object.fromEntries(formData.entries()));

            try {
                const response = await axios.post(`/driver-management/update-document/`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: "Bearer " + this.$store.state.token
                    }
                });

                console.log("Response:", response.data);

                if (hasFile && hasNote) {
                    this.emptyAndPushInfo("Document and Note updated successfully!");
                } else if (hasFile) {
                    this.emptyAndPushInfo("Document updated successfully!");
                } else if (hasNote) {
                    this.emptyAndPushInfo("Note updated successfully!");
                }

                this.setNullEditDocumentIndex();
                this.getDocumentsByDriverID();

            } catch (error) {
                console.error("Update error:", error);
                this.errors.push("Failed to update document.");
            }
        },

        toggleCategory(category) {
            this.expandedCategory = this.expandedCategory === category ? null : category;
            this.expandedSubcategory = {}; // Reset all subcategories when switching category
        },

        toggleSubcategory(category, subcategory) {
            if (!this.expandedSubcategory[category]) {
                this.$set(this.expandedSubcategory, category, subcategory);
            } else {
                this.expandedSubcategory[category] =
                    this.expandedSubcategory[category] === subcategory ? null : subcategory;
            }
        },

    },
    watch: {
        driverId: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.getDocumentsByDriverID();
                }
            }
        }
    }
};
</script>

<style scoped>
h2 {
    font-size: 1.8rem;
    font-weight: bold;
    color: #222;
    margin-bottom: 15px;
}

/* button {
    background: #007bff;
    color: white;
    border: none;
    padding: 10px 15px;
    font-size: 1rem;
    cursor: pointer;
    border-radius: 5px;
    transition: background 0.3s ease;
    margin: 10px 0px;
}

button:hover {
    background: #0056b3;
} */

.errors-list {
    list-style: none;
    padding: 0;
    color: red;
    margin-top: 10px;
}

.info-list {
    list-style: none;
    padding: 0;
    color: green;
    margin-bottom: 20px;
}

.loading {
    font-size: 1.1rem;
    font-weight: bold;
    color: #3f51b5;
    margin-top: 10px;
}

h3 {
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
    margin-top: 20px;
    padding-bottom: 5px;
    border-bottom: 2px solid #3f51b5;
}

h4 {
    font-size: 1.2rem;
    font-weight: bold;
    color: #555;
    margin-top: 15px;
}

.categories-container {
    background: #f8f9fa;
    border-radius: 8px;
    margin-bottom: 20px;
    transition: background 0.3s ease-in-out;
}

h3,
h4 {
    font-weight: 600;
    color: #333;
}

.subcategory {
    margin-top: 10px;
    padding: 12px;
    border-left: 4px solid #3f51b5;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.document-grid {
    border-collapse: collapse;
    margin-top: 10px;
    background: #fff;
    border-radius: 6px;
    overflow: hidden;
}

.document-grid th {
    background: #3f51b5 !important;
    color: white;
    padding: 10px;
    text-align: left;
    font-weight: 500;
}

.document-grid td {
    width: 500px;
    padding: 12px;
    border-bottom: 1px solid #ddd;
}

.document-grid tr {
    height: 73px;
}

.document-table {
    transition: background 0.2s;
}

.view-link {
    color: #007bff;
    font-weight: 500;
    text-decoration: none;
    transition: color 0.2s;
}

.view-link:hover {
    color: #0056b3;
}

tr:hover {
    background: #c5c6c6;
}

.subcategory-header,
.category-header {
    cursor: pointer;
}

.close-btn {
    margin: 0px;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
}

.note-input {
    border: 1px solid;
    border-radius: 8px;
}
</style>
